import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, alpha } from '@mui/material';
import Logo from '../Logo';
import { animated, useTrail } from '@react-spring/web';
import styles from './styles.module.css';
import { transition } from 'src/theme';

// const Trail: React.FC<{ open: boolean; children?: any }> = ({
//   open,
//   children,
// }) => {
//   const items = React.Children.toArray(children);
//   const trail = useTrail(items.length, (index) => ({
//     config: { mass: 5, tension: 2000, friction: 200 },
//     opacity: open ? 1 : 0,
//     x: open ? 0 : 20,
//     height: open ? 110 : 0,
//     from: { opacity: 0, x: 20, height: 0 },
//     delay: open ? index * 300 : 0, // staggered delay
//   }));
//   return (
//     <div>
//       {trail.map((style, index) => {
//         const animatedStyle = (
//           Array.isArray(style) ? style[index] : style
//         ) as any; // Type assertion
//         console.log(animatedStyle);

//         return (
//           <animated.div
//             key={index}
//             className={styles.trailsText}
//             style={{
//               ...animatedStyle,
//               transform: animatedStyle.x.interpolate(
//                 (x) => `translate3d(0,${x}px,0)`,
//               ),
//             }}
//           >
//             <animated.div style={{ height: animatedStyle.height }}>
//               {items[index]}
//             </animated.div>
//           </animated.div>
//         );
//       })}
//     </div>
//   );
// };

type Props = { children?: any };
const LoadingScreen: React.FC<Props> = ({ children }) => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsLoaded(true), 2000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <Box
        sx={{
          alignItems: 'center',
          backgroundColor: ({ palette }) => palette.primaryLight80,
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          justifyContent: 'center',
          left: 0,
          padding: ({ spacing }) => spacing(3),
          position: 'fixed',
          top: 0,
          opacity: isLoaded ? 0 : 1,
          pointerEvents: 'none',
          transition: transition({ duration: 0.5 }),
          width: '100%',
          zIndex: 2000,
        }}
      >
        <Box
          sx={{
            position: 'relative',
            display: 'inline-flex', // Makes the box shrink to fit the CircularProgress
          }}
        >
          <CircularProgress
            size={200}
            thickness={3}
            sx={{ color: ({ palette }) => palette.primary.dark }}
          />
          <Logo
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              width: '45%', // Adjust according to your logo's aspect ratio
              transform: 'translate(-50%, -50%)',
              maxWidth: '70%',
            }}
          />
        </Box>
      </Box>
      {children}
    </>
  );
};
{
  /* <Trail open>
  <span>חשבוניתה</span>
  <span>זה כסף</span>
  <span>קל</span>
</Trail> */
}

export default LoadingScreen;
